import React from 'react';
import styled from 'styled-components';
import { Image } from '../../Image';
import { TabMediaText } from './TabMediaText';
import { isRightAligned } from '../../../utils/variations';
import media from '../../../utils/media';
export const TabMediaContainer = styled.div `
  box-sizing: border-box;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 80px 15px;
  flex-direction: ${({ alignment }) => (isRightAligned(alignment) ? 'row' : 'row-reverse')};

  ${media.mobile} {
    flex-direction: column;
    padding: 30px 10px;
  }
`;
export const Divider = styled.div `
  height: 100%;
  min-width: 30px;

  ${media.mobile} {
    display: none;
  }
`;
const ImageContainer = styled.div `
  max-width: 540px;
  height: 340px;

  ${media.mobile} {
    height: 170px;
    margin-bottom: 30px;
  }
`;
export const TabImageContent = ({ fields }) => {
    if (!fields) {
        return null;
    }
    const { contentAlignment, contentSubtitle, contentTitle, contentBodyText, ctaLink, ctaLinkText, ctaType, thumbnailImage, logoImage, } = fields;
    return (React.createElement(TabMediaContainer, { alignment: contentAlignment.value },
        React.createElement(ImageContainer, null,
            React.createElement(Image, { field: thumbnailImage })),
        React.createElement(Divider, null),
        React.createElement(TabMediaText, { fields: {
                contentSubtitle,
                contentTitle,
                contentBodyText,
                ctaLink,
                ctaLinkText,
                ctaType,
                logoImage,
            } })));
};
